export default "__VITE_ASSET__C3o2fIAz__"